import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react"
import { reportsBaseUrl } from "constant"
import { dashboardConstUrl } from "./const"
import { RootState } from "store/store"
import { handlingErrorResponse } from "utils/HandlingErrorResponse"
import { getAuthToken } from "utils/getAuthToken"
import { IDashboardResponseType, IDashboardEmployeeResponseType, IHolidayResponsesType } from "../type"
import { IResponseType } from "./type"

export const DashboardApi = createApi({
    reducerPath: 'dashboardApi',
    baseQuery: fetchBaseQuery({
        baseUrl: reportsBaseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getAuthToken(getState() as RootState)
            if (token) {
                headers.set('Authorization', `Bearer ${token}`)
            }
            return headers
        },
    }),
    tagTypes: ['Dashboard'],
    endpoints: (builder) => ({
        GetDashboard: builder.query<IResponseType<IDashboardResponseType>, void>({
            query: () => dashboardConstUrl.dashboardUrl,
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'Dashboard', id: 'GetDashboard' }],
        }),
        GetUpcomingBirthdays: builder.query<IResponseType<IDashboardEmployeeResponseType[]>, void>({
            query: () => dashboardConstUrl.upcomingBirthdaysUrl,
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'Dashboard', id: 'GetUpcomingBirthdays' }],
        }),
        GetEmployeeOnLeaves: builder.query<IResponseType<IDashboardEmployeeResponseType[]>, void>({
            query: () => dashboardConstUrl.employeeOnLeavesUrl,
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'Dashboard', id: 'GetEmployeeOnLeaves' }],
        }),
        GetWorkAnniversaries: builder.query<IResponseType<IDashboardEmployeeResponseType[]>, void>({
            query: () => dashboardConstUrl.workAnniversariesUrl,
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'Dashboard', id: 'GetWorkAnniversaries' }],
        }),
        GetUpcomingRenewalContracts: builder.query<IResponseType<IDashboardEmployeeResponseType[]>, void>({
            query: () => dashboardConstUrl.upcomingRenewalContractsUrl,
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'Dashboard', id: 'GetUpcomingRenewalContracts' }],
        }),
        GetHolidays: builder.query<IResponseType<IHolidayResponsesType[]>, void>({
            query: () => dashboardConstUrl.holiDaysUrl,
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'Dashboard', id: 'GetHolidays' }],
        }),
    }),
})